import { useId } from 'react'

/*
 * Resumo de um verbete do dicionário, com link para ele. Os textos seguem o exemplo do
 * funk de `Dictionary.tsx` — mudou lá, confira aqui. Abre por CSS (hover e foco), sem
 * estado: `:focus-within` mantém o balão aberto enquanto o foco anda até o link.
 */
const TIPS = {
  afinidade: 'O território é característico da audiência? Compara com a população: 220 quer dizer que a audiência está nele 2,2 vezes mais que o Brasil.',
  saturacao: 'O público do concorrente mais forte, na etapa do funil que o KPI pede, já está aqui? Compara com a média da própria audiência: 150 quer dizer 1,5 vez mais que o público médio.',
  alcance: 'Quantas pessoas da audiência estão no território, em porcentagem. É o que impede índice alto sobre pouca gente de virar recomendação.',
  ocupacao: 'Quem detém o território hoje: cruza a força da sua marca com a do concorrente mais forte, cada uma contra o limiar.',
  prioridade: 'Score de 0 a 1 que ordena os territórios. O KPI do brief decide quanto pesa cada métrica — o objetivo muda a conta, não só o texto.',
} as const

export function Tip({ term, align = 'start' }: { term: keyof typeof TIPS; align?: 'start' | 'end' }) {
  const id = useId()
  return (
    <span className={`tip tip-${align}`}>
      <button type="button" className="tip-trigger" aria-describedby={id} aria-label="O que é isto?">?</button>
      <span className="tip-bubble" role="tooltip" id={id}>
        {TIPS[term]} <a href={`/dicionario#${term}`}>Ver no dicionário</a>
      </span>
    </span>
  )
}
